import React from "react";
import ReactTable from "../../../components/ReactTable";
import editBond from "../../../assets/editBond.png";
import { createColumnHelper } from "@tanstack/react-table";
import { HiOutlineTrash } from "react-icons/hi2";
import { CiEdit } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import "ckeditor5/ckeditor5.css";
import { useSelector } from "react-redux";

function FaqManage() {
  const columnHelper = createColumnHelper();
  const navigate = useNavigate();
  const { cmsData } = useSelector((state) => state.cmsData);

  console.log("cmsData", cmsData);

  const homeData = [
    { name: "header", id: 1 },
    { name: "hero", id: 2 },
    { name: "footer", id: 3 },
    { name: "slider", id: 4 },
    { name: "header", id: 5 },
    { name: "header", id: 6 },
  ];

  const columns = [
    columnHelper.accessor("questtion", {
      cell: (info) => <div className="text-left">{info.renderValue()}</div>,
      header: () => <div className="text-left font-semibold">Question</div>,
    }),

    columnHelper.accessor("answer", {
      cell: (info) => {
        return (
          <>
            <div className="text-left">{info.renderValue()}</div>
          </>
        );
      },
      header: () => <div className="text-left font-semibold">Answer</div>,
      meta: { width: "200px" },
    }),

    // columnHelper.accessor("added", {
    //   cell: (info) => <div className="text-center">{"N/A"}</div>,
    //   header: () => <div className="text-center font-semibold">Image</div>,
    //   meta: { width: "200px" },
    // }),

    // columnHelper.accessor("modify", {
    //   cell: (info) => <div className="text-center">{"N/A"}</div>,
    //   header: () => <div className="text-center font-semibold">link</div>,
    //   meta: { width: "150px" },
    // }),

    columnHelper.accessor("actions", {
      cell: (info) => {
        // const uniqueId = info?.row?.original?.id;
        return (
          <div className="flex justify-center gap-5">
            {/* <img
              //   onClick={() => Navigate(`/bond/edit`, { state: { uniqueId } })}
              src={editBond}
              alt="Edit"
              className="cursor-pointer"
            /> */}
            <HiOutlineTrash size={24} color="red" />
            <CiEdit
              size={24}
              color="#035c98"
              onClick={() => navigate("/cms/edit/faq")}
            />
          </div>
        );
      },
      header: () => <div className="text-center font-semibold">Actions</div>,
    }),
  ];
  return (
    <div className="w-full pl-5 pt-5">
      <div className="bg-white p-4 rounded-lg mb-6 shadow-md mt-10">
        <h1 className="text-[#252C32] text-[24px] font-bold">Faq Management</h1>
      </div>

      <div className="w-full flex justify-end items-center p-5">
        <button
          onClick={() => navigate("/cms/add/faq")}
          className="bg-[#ffb819] px-4 py-2 rounded-lg font-montserrat"
        >
          Add
        </button>
      </div>

      <div className="overflow-x-auto w-full mb-6">
        <ReactTable
          key={JSON?.stringify(cmsData?.faqs ? cmsData?.faqs : [])}
          defaultData={cmsData?.faqs ? cmsData?.faqs : []}
          columns={columns}
          className="table-auto w-full text-sm border-collapse"
        />
      </div>

      {/* Pagination Section
  {bondDetails?.length > 0 && (
    <div className="w-full mt-4 flex justify-center">
      <CustomPagination
        currentPage={page}
        setCurrentPage={setPage}
        totalItems={total}
        itemsPerPage={pageSize}
        maxPageNumbersToShow={5}
      />
    </div>
  )} */}
    </div>
  );
}

export default FaqManage;
